import {usePageData} from '../../core/PageData'
import {MenuItem} from './MenuItem'

export function MenuInner() {
  const {pageTitle} = usePageData()

  return (
    <>
      <MenuItem title={pageTitle || ''} />
    </>
  )
}
